module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_3_2.85361a95.jpeg";